module.exports = "../images/fishing-lodge-11.jpg?v=6b48556";